import atypes from '../actions/actionTypes';
import { errorTemplate, getError } from './utils';
import * as _ from 'lodash';

const _template = {
    error: errorTemplate(),
    configure: {},
    selectedTenantLocation: {},
};

function newState() {
    return {
        ..._.cloneDeep(_template)
    }
}

export default function(state = newState(), action) {
    switch (action.type) {
        case atypes.LOAD_CONFIG_REQUEST:
            return {
                ...state,
                error: errorTemplate(),
            };

        case atypes.LOAD_CONFIG_SUCCESS:
            return {
                ...state,
                configure: action.payload,
                error: errorTemplate(),
            };

        case atypes.LOAD_CONFIG_FAILURE: {
            return {
                ...state,
                error: getError(action.payload, 'Failed to load Data Infrastructure Insights configuration.'),
                extmode: false,
            };
        }
        case atypes.SET_TENANT_LOCATION: {
            return {
                ...state,
                selectedTenantLocation: action.payload,
            };
        }
        case atypes.SET_TENANT_LOCATION_FAILURE: {
            return {
                ...state,
                error: getError(action.payload, 'Failed to set requested Data Infrastructure Insights location.'),
                selectedTenantLocation: {},
            };
        }
        default:
            return state
    }
}
